import { readOtpSendLimitSeconds, type HttpPost } from '@/shared/infra/http'
import { ClaimSendLimitError } from '@/shared/domain'
import type {
  SendContactClaimOtp,
  SendContactClaimOtpParams,
} from '@/modules/auth/use-cases'

type SendIdentityOtpBody = {
  identifier: string
  identifierType: 'email' | 'phone'
  purpose: 'claim'
}

export class EdgeSendContactClaimOtpRepository {
  constructor(private readonly httpClient: HttpPost) {}

  execute: SendContactClaimOtp = async (params: SendContactClaimOtpParams) => {
    try {
      await this.httpClient.post<SendIdentityOtpBody, { sent: boolean }>({
        url: '/users/send-identity-otp',
        body: {
          identifier: params.identifier,
          identifierType: params.identifierType,
          purpose: 'claim',
        },
      })
    } catch (err) {
      const retryAfterSeconds = readOtpSendLimitSeconds(err)
      if (retryAfterSeconds !== null) {
        throw new ClaimSendLimitError(params.identifierType, retryAfterSeconds)
      }
      throw err
    }
  }
}
